import {Component} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {Router} from '@angular/router';
import {SimpleNavigationPathDataService} from '../../../services/data-services/navigation-data-services';
import {
  DatatableActionButton,
  DatatableEvent,
  DatatableHandler,
  DatatableHandlerEvents,
  DatatableHandlerSettings,
  IconType,
} from '../../../components/datatables/datatable/datatable/datatable.component';
import {SimpleModalService} from 'ngx-simple-modal';
import {ExaminersClient} from '../../../generated-client/generated-api-client';
import {ToastrService} from 'ngx-toastr';
import {DataTableRoutes} from 'src/app/constants/datatableUrls';
import {ErrorProcessorService} from '../../../services/error-processor.service';
import {ConfirmReasonModalComponent} from "../../../components/modals/archive-confirm-modal/confirm-reason-modal.component";
import {TenantService} from "../../../services/tenant.service";
import { PersistentDataService } from '../../../services/persistent-data.service';

@Component({
  selector: 'app-examiner-list',
  templateUrl: './examiner-list.component.html',
  styleUrls: ['./examiner-list.component.sass'],
})
export class ExaminerListComponent {
  dtHandler?: DatatableHandler;
  dtSettings: DatatableHandlerSettings = DatatableHandler.getDefaultSettings();
  dtDataSourceUrl: string = DataTableRoutes.ExaminerList;
  dtEvents: DatatableHandlerEvents = DatatableHandler.getDefaultEvents();

  constructor(
    private titleService: Title,
    private router: Router,
    private examinerNavigationService: SimpleNavigationPathDataService,
    private _modalService: SimpleModalService,
    private _examinerClient: ExaminersClient,
    private toastr: ToastrService,
    private errorProcessorService: ErrorProcessorService,
    private _tenantService: TenantService,
    private _pDservice: PersistentDataService

  ) {
    this.titleService.setTitle('Vizsgabiztosok');

    this.navigateBackData = this.router.url;
    this.navigateToData = this.router.url;

    this.dtSettings.pageSize = _pDservice.examExaminerPageSize;
    this.dtSettings.searchString = _pDservice.examExaminerSearchString;
    this.dtSettings.buttons = [
      {
        text: 'Új vizsgabiztos',
        class: 'btn-primary text-white',
        url: '/examiners/new',
      },
    ];
    this.dtSettings.actions = this._dtActionButtonsFn;

    this.dtSettings.additionalColumns = [
      {
        targets: 5,
        orderable: false,
      },
    ];

    this.dtSettings.additionalRequestData = () => {
      if (this.dtHandler?.pageSize != null)
        _pDservice.examExaminerPageSize = this.dtHandler?.pageSize
      if (this.dtHandler?.searchString != null)
        _pDservice.examExaminerSearchString = this.dtHandler?.searchString
      return {
        tenantId: this._tenantService.activeTenantId,
      };
    };
  }

  set navigateBackData(value: string) {
    this.examinerNavigationService.navigateBackPath = value;
  }

  set navigateToData(value: string) {
    this.examinerNavigationService.navigateToPath = value;
  }

  onDtInit(dtHandler: DatatableHandler): void {
    this.dtHandler = dtHandler;
    this.dtHandler.create();
  }

  onDtAction(event: DatatableEvent) {
    if (event.actionId === 'archive') {
      this.archive(event.data['id']);
    }
    if (event.actionId === 'activate') {
      this.activate(event.data['id']);
    }
  }

  private archive(id: string): void {
    this._modalService
      .addModal(ConfirmReasonModalComponent, {
        title: 'Vizsgabiztos archiválása',
        message: 'Biztosan archiválni szeretné a kiválasztott vizsgabiztost?',
        description:
          'A folyamat hatására a még szerkeszthető jegyzőkönyvek, melyen a vizsgabiztos szerepel módosításra kerülnek.',
        confirmText: 'Igen',
        confirmClass: 'btn-danger text-white',
      })
      .subscribe(result => {
        if (result) {
          this._examinerClient.archive(id, result.reason).subscribe(
            () => {
              this.dtHandler?.refresh();
              this.toastr.success('Sikeres archiválás');
            },
            error => this.errorProcessorService.processError(error, true)
          );
        }
      });
  }

  private activate(id: string): void {
    this._modalService
      .addModal(ConfirmReasonModalComponent, {
        title: 'Vizsgabiztos aktiválása',
        message: 'Biztosan aktiválni szeretné a kiválasztott vizsgabiztost?',
        confirmText: 'Igen',
        confirmClass: 'btn-primary text-white',
      })
      .subscribe(result => {
        if (result) {
          this._examinerClient.unArchive(id, result.reason).subscribe(
            () => {
              this.dtHandler?.refresh();
              this.toastr.success('Sikeres aktiválás');
            },
            error => this.errorProcessorService.processError(error, true)
          );
        }
      });
  }

  private _dtActionButtonsFn: (data: any) => DatatableActionButton[] = data => {
    const isArchived = data['isArchived'];

    const archiveAction = isArchived
      ? new DatatableActionButton('activate', 'Vizsgabiztos aktiválása', 'unarchive', undefined, IconType.Danger)
      : new DatatableActionButton('archive', 'Vizsgabiztos archiválása', 'archive', undefined, IconType.Success);

    return [archiveAction];
  };
}
